/**
 * The `ch-tabular-grid-column-display` component is responsible for determining the
 * visibility of a grid column and updating its hidden property based on
 * whether the monitored class is visible or not.
 */
export class ChTabularGridColumnDisplay {
    constructor() {
        this.column = undefined;
    }
    observer = new IntersectionObserver(() => {
        this.column.hidden = getComputedStyle(this.el).display === "none";
    });
    el;
    componentWillLoad() {
        this.observer.observe(this.el);
    }
    static get is() { return "ch-tabular-grid-column-display"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-column-display.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-column-display.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChTabularGridColumnElement",
                    "resolved": "HTMLChTabularGridColumnElement",
                    "references": {
                        "HTMLChTabularGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChTabularGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The column element that is being monitored."
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
